module.exports = __webpack_public_path__ + "static/media/_MIC2527.image.ae92ce2a.png";